import Axios from "../config/config";


//Media API
export const MEDIA_IMAGE_LISTING = async (body) => {
    try {
        const response = await Axios.post('media-list/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};

export const SECTION_VIDEO_LIST = async (body) => {
    try {
        const response = await Axios.post('list-section-videos/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};


export const DELETE_SELECT_VIDEO = async (body) => {
    try {
        const response = await Axios.post('delete-section-video/', body);
        return response;
    } catch (error) {
        console.error(error);
    }
};